/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetContactMaterialsExpiredListResponseData,
  GetContactMaterialsExpiredListResponseDataFromJSON,
  GetContactMaterialsExpiredListResponseDataFromJSONTyped,
  GetContactMaterialsExpiredListResponseDataToJSON
} from './GetContactMaterialsExpiredListResponseData'

/**
 *
 * @export
 * @interface GetContactMaterialsExpiredListResponse
 */
export interface GetContactMaterialsExpiredListResponse {
  /**
   *
   * @type {number}
   * @memberof GetContactMaterialsExpiredListResponse
   */
  status?: number
  /**
   *
   * @type {GetContactMaterialsExpiredListResponseData}
   * @memberof GetContactMaterialsExpiredListResponse
   */
  data?: GetContactMaterialsExpiredListResponseData
}

export function GetContactMaterialsExpiredListResponseFromJSON(json: any): GetContactMaterialsExpiredListResponse {
  return GetContactMaterialsExpiredListResponseFromJSONTyped(json, false)
}

export function GetContactMaterialsExpiredListResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetContactMaterialsExpiredListResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetContactMaterialsExpiredListResponseDataFromJSON(json['data'])
  }
}

export function GetContactMaterialsExpiredListResponseToJSON(
  value?: GetContactMaterialsExpiredListResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetContactMaterialsExpiredListResponseDataToJSON(value.data)
  }
}
